export default "__VITE_ASSET__BEROjdct__"